import { RootAppState } from 'store/configureStore'

export const projectStatusChangeInPortalAllowedSelector = (
  state: RootAppState,
) => {
  return state.project.activeProject?.statusChangeInPortalIsAllowed
}
